import React from 'react';
import { Typography } from '@mui/material';
import { WriteoffSearchView } from '../../../../../../services/WriteoffService/types';

// Status display names
const statusDisplayNames: Record<string, string> = {
  'DRAFT': 'Draft',
  'SUBMITTED': 'In Approval',
  'APPROVED': 'Postable',
  'REJECTED': 'Rejected',
  'POSTED': 'Posted',
};

interface LookupStatusTemplateProps {
  status?: string;
}

/**
 * Status display for lookup grid (text-only, no chip).
 */
export const LookupStatusTemplate: React.FC<LookupStatusTemplateProps> = ({ status }) => {
  const displayName = statusDisplayNames[status || ''] || status || '-';
  return <Typography variant="body2">{displayName}</Typography>;
};

/** Syncfusion grid template wrapper */
export const lookupStatusTemplate = (props: WriteoffSearchView) => (
  <LookupStatusTemplate status={props.status} />
);

export default LookupStatusTemplate;
